// Login.js
import React, {useEffect, useState} from 'react';
import {getFirestore, doc, getDoc} from "firebase/firestore";
import {getAuth, sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink} from 'firebase/auth';
import {useSnackbar} from "notistack";
import {Button} from "@mui/material";
import './Styles.css';


function Login() {
  const {enqueueSnackbar} = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  const [error, setError] = useState(null);
  useEffect(() => {
    if (error) {
      enqueueSnackbar(error, {variant: 'error'});
    }
  }, [error, enqueueSnackbar]);

  const [message, setMessage] = useState(null);
  useEffect(() => {
    if (message) {
      enqueueSnackbar(message, {variant: 'success'});
    }
  }, [message, enqueueSnackbar]);

  const auth = getAuth();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  const handleLogin = async () => {
    setLoading(true);
    // make sure we have registered user with this email
    const db = getFirestore();
    const docRef = doc(db, "users", email);
    const myDoc = await getDoc(docRef);
    if (myDoc.exists()) {
      const actionCodeSettings = {
        url: window.location.href,
        handleCodeInApp: true
      };

      try {
        await sendSignInLinkToEmail(auth, email, actionCodeSettings);
        window.localStorage.setItem('emailForSignIn', email);
        setMessage("Link sent to your email. Please check your inbox.");
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    } else {
      setError("No user with this email found. Please contact the administrator or try again.");
      setLoading(false);
    }
  };

  // Check for email link on component mount
  useEffect(() => {
    const checkForEmailLink = async () => {
      setLoading(true);
      if (isSignInWithEmailLink(auth, window.location.href)) {
        let storedEmail = window.localStorage.getItem('emailForSignIn');

        if (!storedEmail) {
          storedEmail = window.prompt('Please provide your email for confirmation');
        }

        try {
          await signInWithEmailLink(auth, storedEmail, window.location.href);
          window.localStorage.removeItem('emailForSignIn');
          if (window.history && window.history.replaceState) {
            window.history.replaceState({}, document.title, window.location.pathname);
          }
          setMessage("Successfully signed in!");
        } catch (err) {
          setError(err.message);
        }
      }
      setLoading(false);
    };
    checkForEmailLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="allocate-partial-container">
      <img className='login-logo'
        src='manifest-icon-192.maskable.png'
        alt='alaric-logo'
      />
      <h3>Sign in</h3>
      <p>Enter your email to start</p>
      <div className="login-form">
        <input
          className='login-text-input'
          type='email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder='name@domain.ext'
        />
        <Button
          className='login-button'
          onKeyDown={handleKeyDown}
          onClick={handleLogin}
          disabled={loading || !email}>
          {loading ? "Loading..." : "Send me a login link"}
        </Button>
      </div>
    </div>
  );
}

export default Login;
